



























import Vue from "vue";

import IconCardVocabulary from "@joyz/app-core/assets/icons/transparent/DrillVocabulary.svg";
import IconCorrect from "@joyz/app-core/assets/icons/Correct.svg";
import IconIncorrect from "@joyz/app-core/assets/icons/Incorrect.svg";
import IconSkipped from "@joyz/app-core/assets/icons/misc/DrillSkip.svg";

import {
  DrillQuestionAndAnswers,
  DrillUserAnswer,
  DrillLearningStatus,
  ApiDrillVocabulary,
  // ApiDrillVocabularyOption,
  RespDrillVocabularyAnswer,
  DrillVocabularyAnswer
} from "@tt-app/models/exercise";

interface Data {
  icons: { [key: string]: string };
}

interface Methods {
  getCorrectnessIcon: (answer: DrillUserAnswer) => string;
  getLearnStatus: (learnStatus: DrillLearningStatus) => number;
}

interface Computed {
  word: string;
  userAnswer?: string;
}

interface Props {
  exercise: DrillQuestionAndAnswers;
  questionIndex: number;
}

/**
 * Two lines of texts are displayed in the DrillAnswerVocabulary:
 * - bold text is the question
 * - italic grey text is the user answer or the correct answer if the question
 *   was skipped
 */
export default Vue.extend<Data, Methods, Computed, Props>({
  name: "DrillAnswerVocabulary",

  props: {
    exercise: { type: Object as () => DrillQuestionAndAnswers, required: true },
    questionIndex: { type: Number, required: true }
  },

  data() {
    return {
      icons: {
        drillType: IconCardVocabulary,
        skipped: IconSkipped
      }
    };
  },

  computed: {
    word() {
      return (this.exercise.question as ApiDrillVocabulary).word.spelling;
      // --- If the user answer has to be returned: ---
      // const options = (this.exercise.question as ApiDrillVocabulary).options;
      // const lastAnswer = this.exercise.lastAnswer;

      // // Question was skipped
      // if (!lastAnswer) {
      //   return (this.exercise.question as ApiDrillVocabulary).word.spelling;
      // }

      // const selectedId = (lastAnswer.submittedAnswer as DrillVocabularyAnswer).optionId;
      // const selectedOption: ApiDrillVocabularyOption | undefined = options.find(
      //   option => option.id === selectedId
      // );

      // // WARNING! selected option not found
      // if (!selectedOption) {
      //   return "## SELECTED OPTION NOT FOUND ##";
      // }

      // return selectedOption.text;
    },

    userAnswer() {
      // --- If user answer translation has to be returned: ---
      // const skipped = this.exercise.skipped as RespDrillVocabularyAnswer | undefined;
      // const lastAnswer = this.exercise.lastAnswer;
      // const correction = lastAnswer
      //   ? (lastAnswer.correction as RespDrillVocabularyAnswer)
      //   : undefined;
      // const translations = skipped
      //   ? skipped.translations
      //   : correction
      //   ? correction.translations
      //   : undefined;

      // // Question has no translations
      // if (!translations) {
      //   return undefined;
      // }

      // // Question word is translated: show the translation only if skipped. If it is
      // // skipped, the original word (in English) is shown, hence the translation. Otherwise,
      // // the options being in Japanese, there is no need to display the translations
      // if (translations.word && skipped) {
      //   return translations.word;
      // }

      // // Selected option is translated
      // if (translations.options && lastAnswer) {
      //   const selectedId = (lastAnswer.submittedAnswer as DrillVocabularyAnswer).optionId;
      //   const selectionTranslation = translations.options.find(t => t.id === selectedId);
      //   return selectionTranslation ? selectionTranslation.text : undefined;
      // }

      // return undefined;

      // --- If user answer OR correct answer (if skipped) has to be returned: ---
      const skipped = this.exercise.skipped as RespDrillVocabularyAnswer | undefined;
      if (skipped) {
        const correctId = skipped.correctId;
        const correctTranslation = (this.exercise.question as ApiDrillVocabulary).options.find(
          t => t.id === correctId
        );

        return correctTranslation ? correctTranslation.text : undefined;
      }

      const lastAnswer = this.exercise.lastAnswer;
      if (!lastAnswer) {
        return undefined;
      }

      const selectedId = (lastAnswer.submittedAnswer as DrillVocabularyAnswer).optionId;
      const selectionTranslation = (this.exercise.question as ApiDrillVocabulary).options.find(
        t => t.id === selectedId
      );

      return selectionTranslation ? selectionTranslation.text : undefined;
    }
  },

  methods: {
    getCorrectnessIcon(answer) {
      return answer.correction.isCorrect ? IconCorrect : IconIncorrect;
    },

    getLearnStatus(learnStatus) {
      return learnStatus !== null ? learnStatus : -1;
    }
  }
});
